/**
 * Bundle tiers — Buy 1 / 3 / 5 / 10 with a variant selector per unit.
 *
 * This file is PRESENTATION ONLY. The actual discount is applied by native
 * Shopify automatic discounts keyed on cart quantity, so if this script fails
 * to load the customer still gets the correct price at checkout.
 */
(function () {
  if (customElements.get('bundle-tiers')) return;

  var TIMER_KEY = 'bt-deadline';

  function json(el, sel) {
    var node = el.querySelector(sel);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Stable, unique id per user action. The Shopify custom pixel and the PHX
   * conversion postback both send this as event_id so Meta / TikTok can
   * deduplicate browser and server copies of the same event.
   */
  function eventId() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'e-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class BundleTiers extends HTMLElement {
    connectedCallback() {
      this.tiers = json(this, '[data-bt-tiers]') || [];
      this.variants = json(this, '[data-bt-variants]') || [];
      this.optionDefs = json(this, '[data-bt-options]') || [];

      if (!this.tiers.length || !this.variants.length) return;

      this.currency = this.dataset.currency || 'USD';
      this.basis = this.dataset.savingsBasis || 'compare';
      this.afterAdd = this.dataset.afterAdd || 'cart';
      this.addText = this.dataset.addText || 'Add to cart';

      this.list = this.querySelector('[data-bt-list]');
      this.addButton = this.querySelector('[data-bt-add]');
      this.addLabel = this.querySelector('[data-bt-add-text]');
      this.buyNowButton = this.querySelector('[data-bt-buynow]');
      this.errorEl = this.querySelector('[data-bt-error]');

      // Default selection: the tier carrying a badge, else the largest tier,
      // else the first. Most-popular-preselected lifts AOV measurably.
      var badged = this.tiers.findIndex(function (t) {
        return t.badge && t.badge.trim();
      });
      this.selected = badged > -1 ? badged : 0;

      this.selections = {}; // tierIndex -> array of option-value arrays
      this.renderTiers();
      this.bind();
      this.startTimer();
      this.syncAddButton();
    }

    /* ---------- pricing ---------- */

    unitPrice() {
      var v = this.firstAvailable();
      return v ? v.price : Number(this.dataset.unitPrice || 0);
    }

    unitCompare() {
      var v = this.firstAvailable();
      var c = v ? v.compare : Number(this.dataset.unitCompare || 0);
      var p = this.unitPrice();
      return c && c > p ? c : p;
    }

    firstAvailable() {
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].available) return this.variants[i];
      }
      return this.variants[0] || null;
    }

    tierMath(tier) {
      var qty = tier.qty;
      var pct = tier.percent || 0;
      var subtotal = this.unitPrice() * qty;

      // Shopify floors the automatic percentage discount PER UNIT and then
    // multiplies by quantity - it does not floor the line total. Verified
    // against this store's own cart:
    //   5 x $19.99, 45% off -> floor(899.55) = 899 off each -> charges $55.00
    //   flooring the line total would print $54.98 - two cents under
    // Getting this wrong is not cosmetic: the tier card would disagree with
    // the cart, and the AddToCart value sent to Meta would never match the
    // Purchase value PHX reports.
      var unit = this.unitPrice();
    var total = (unit - Math.floor((unit * pct) / 100)) * qty;

      // The struck-through figure can be the compare-at total (bigger, better
      // contrast) or the plain regular-price total.
      var basisUnit = this.basis === 'price' ? this.unitPrice() : this.unitCompare();
      var was = basisUnit * qty;
      // Savings % is ALWAYS the discount actually configured for the tier, and
      // therefore always matches the automatic discount Shopify will apply.
      // Deriving it from the struck-through figure would print a bigger number
      // than the discount the customer really receives.
      return { qty: qty, total: total, was: was, savePct: pct, each: Math.round(total / qty) };
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    /* ---------- rendering ---------- */

    renderTiers() {
      var self = this;
      this.list.innerHTML = '';

      this.tiers.forEach(function (tier, index) {
        var m = self.tierMath(tier);
        var card = document.createElement('div');
        card.className = 'bt-tier';
        card.dataset.btTier = String(index);
        card.dataset.selected = index === self.selected ? 'true' : 'false';

        var sub =
          tier.percent > 0
            ? '<span class="bt-tier__save">Save ' + m.savePct + '%</span>'
            : 'Standard price';

        var compare =
          m.was > m.total
            ? '<span class="bt-tier__compare">' + self.money(m.was) + '</span>'
            : '';

        var each =
          tier.qty > 1
            ? '<span class="bt-tier__each">' + self.money(m.each) + ' each</span>'
            : '';

        var badge =
          tier.badge && tier.badge.trim()
            ? '<span class="bt-tier__badge">' + esc(tier.badge) + '</span>'
            : '';

        card.innerHTML =
          badge +
          '<label class="bt-tier__head">' +
          '<input class="bt-tier__input" type="radio" name="bt-tier-' +
          (self.dataset.productId || '0') +
          '" value="' +
          index +
          '"' +
          (index === self.selected ? ' checked' : '') +
          '>' +
          '<span class="bt-tier__radio" aria-hidden="true"></span>' +
          '<span class="bt-tier__text">' +
          '<span class="bt-tier__label">Buy ' +
          tier.qty +
          '</span>' +
          '<span class="bt-tier__sub">' +
          sub +
          '</span>' +
          '</span>' +
          '<span class="bt-tier__prices">' +
          '<span class="bt-tier__price">' +
          self.money(m.total) +
          '</span>' +
          compare +
          each +
          '</span>' +
          '</label>' +
          '<div class="bt-rows"><div class="bt-rows__inner"><div class="bt-rows__pad" data-bt-rows></div></div></div>';

        self.list.appendChild(card);

        var wrap = card.querySelector('.bt-rows');
        if (wrap) wrap.inert = index !== self.selected;
      });

      this.renderRows(this.selected);
    }

    defaultRow() {
      var v = this.firstAvailable();
      return v ? v.options.slice() : this.optionDefs.map(function (o) { return o.values[0]; });
    }

    renderRows(index) {
      var self = this;
      var tier = this.tiers[index];
      var card = this.list.querySelector('[data-bt-tier="' + index + '"]');
      if (!card || !tier) return;
      var host = card.querySelector('[data-bt-rows]');

      // Single-variant products have nothing to choose.
      var hasChoices = this.optionDefs.length && !(this.variants.length === 1);
      if (!hasChoices) {
        host.innerHTML = '';
        this.selections[index] = new Array(tier.qty).fill(this.defaultRow());
        return;
      }

      if (!this.selections[index] || this.selections[index].length !== tier.qty) {
        var existing = this.selections[index] || [];
        var rows = [];
        for (var i = 0; i < tier.qty; i++) {
          rows.push(existing[i] ? existing[i].slice() : this.defaultRow());
        }
        this.selections[index] = rows;
      }

      var html =
        '<div class="bt-rows__legend">' +
        this.optionDefs
          .map(function (o) { return esc(o.name); })
          .join(' &middot; ') +
        '</div>';

      this.selections[index].forEach(function (rowValues, r) {
        html +=
          '<div class="bt-row">' +
          '<span class="bt-row__n">#' +
          (r + 1) +
          '</span>' +
          '<div class="bt-row__selects">' +
          self.optionDefs
            .map(function (opt, oi) {
              return (
                '<select class="bt-select" data-bt-row="' +
                r +
                '" data-bt-opt="' +
                oi +
                '" aria-label="' +
                esc(opt.name) +
                ' for item ' +
                (r + 1) +
                '">' +
                opt.values
                  .map(function (val) {
                    var ok = self.valueAvailable(rowValues, oi, val);
                    return (
                      '<option value="' +
                      esc(val) +
                      '"' +
                      (rowValues[oi] === val ? ' selected' : '') +
                      (ok ? '' : ' disabled') +
                      '>' +
                      esc(val) +
                      (ok ? '' : ' — sold out') +
                      '</option>'
                    );
                  })
                  .join('') +
                '</select>'
              );
            })
            .join('') +
          '</div>' +
          '</div>';
      });

      host.innerHTML = html;
    }

    valueAvailable(rowValues, optionIndex, value) {
      var candidate = rowValues.slice();
      candidate[optionIndex] = value;
      return this.variants.some(function (v) {
        if (!v.available) return false;
        for (var i = 0; i < candidate.length; i++) {
          // Only constrain options at or before the one being changed, so a
          // downstream option never blocks an upstream choice outright.
          if (i !== optionIndex && v.options[i] !== candidate[i]) return false;
        }
        return true;
      });
    }

    matchVariant(values) {
      var exact = this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
      if (exact) return exact;
      // Fall back to the first available variant sharing the first option.
      return (
        this.variants.find(function (v) {
          return v.available && v.options[0] === values[0];
        }) || this.firstAvailable()
      );
    }

    /* ---------- events ---------- */

    bind() {
      var self = this;

      this.list.addEventListener('change', function (e) {
        var sel = e.target.closest('.bt-select');
        if (sel) {
          var r = Number(sel.dataset.btRow);
          var oi = Number(sel.dataset.btOpt);
          var rows = self.selections[self.selected];
          if (!rows || !rows[r]) return;
          rows[r][oi] = sel.value;
          // Re-render to refresh sold-out states across the row.
          self.renderRows(self.selected);
          self.syncAddButton();
          return;
        }

        var radio = e.target.closest('.bt-tier__input');
        if (radio) self.select(Number(radio.value));
      });

      this.list.addEventListener('click', function (e) {
        if (e.target.closest('.bt-select') || e.target.closest('label')) return;
        var card = e.target.closest('[data-bt-tier]');
        if (card) self.select(Number(card.dataset.btTier));
      });

      this.addButton.addEventListener('click', function () { self.add(); });

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', function () { self.add('checkout'); });
      }
    }

    select(index) {
      if (index === this.selected || !this.tiers[index]) return;
      this.selected = index;
      var cards = this.list.querySelectorAll('[data-bt-tier]');
      for (var i = 0; i < cards.length; i++) {
        var isActive = Number(cards[i].dataset.btTier) === index;
        cards[i].dataset.selected = isActive ? 'true' : 'false';
        // Keep collapsed rows in the DOM so the height transition can animate,
        // but make them unreachable by keyboard and screen readers.
        var wrap = cards[i].querySelector('.bt-rows');
        if (wrap) wrap.inert = !isActive;
      }
      var input = this.list.querySelector('[data-bt-tier="' + index + '"] .bt-tier__input');
      if (input) input.checked = true;
      this.renderRows(index);
      this.syncAddButton();
    }

    syncAddButton() {
      var tier = this.tiers[this.selected];
      if (!tier) return;
      var m = this.tierMath(tier);
      this.addLabel.textContent = this.addText + ' · ' + this.money(m.total);
    }

    /* ---------- add to cart ---------- */

    add(destinationOverride) {
      var self = this;
      var destination = destinationOverride || this.afterAdd;
      var tier = this.tiers[this.selected];
      if (!tier) return;

      var rows = this.selections[this.selected] || [];
      if (!rows.length) rows = new Array(tier.qty).fill(this.defaultRow());

      // Group identical variants into one line so the cart stays readable.
      var grouped = {};
      var order = [];
      rows.forEach(function (values) {
        var v = self.matchVariant(values);
        if (!v) return;
        if (!grouped[v.id]) {
          grouped[v.id] = 0;
          order.push(v.id);
        }
        grouped[v.id] += 1;
      });

      var items = order.map(function (id) {
        return { id: Number(id), quantity: grouped[id] };
      });

      if (!items.length) {
        this.showError('Please choose an option for each item.');
        return;
      }

      var id = eventId();

      this.errorEl.hidden = true;
      this.addButton.disabled = true;
      if (this.buyNowButton) this.buyNowButton.disabled = true;
      this.addLabel.textContent = 'Adding…';

      // Ask Shopify to re-render the section(s) that contain a cart, in the
      // same request that adds the items. The drawer then repaints from
      // server-rendered HTML with no second round trip and no chance of the
      // markup disagreeing with the cart.
      var sectionIds = this.cartSectionIds();

      var payload = { items: items };
      if (sectionIds) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function (body) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          self.announceCartUpdate(body);

          // Single, explicit tracking surface. Shopify's own web pixel also
          // emits product_added_to_cart for this same /cart/add.js call, so the
          // pixel must key off ONE of the two — not both — or every add counts
          // twice. Payload is deliberately complete so the pixel never has to
          // re-derive prices from the DOM.
          self.emit('mainplug:add_to_cart', {
            eventId: id,
            tier: tier.qty,
            discountPercent: tier.percent || 0,
            quantity: tier.qty,
            value: self.tierMath(tier).total / 100,
            currency: self.currency,
            items: items
          });

          // The cart drawer is the whole post-add experience on this store.
          // When it is on the page it has already slid out (it listens for the
          // 'cart:update' dispatched just above), so we stay put — navigating
          // would throw away the drawer and dump the customer on the cart page,
          // which is exactly what we are trying to avoid. The `after_add`
          // block setting is deliberately ignored in that case so it cannot
          // break the flow from the theme editor.
          if (document.querySelector('cart-drawer-component')) {
            self.resetButtons();
            return;
          }

          if (destination === 'checkout') {
            // DO NOT send the customer to /checkout. Verified on this store:
            // a direct /checkout navigation lands on Shopify's own checkout and
            // bypasses PHX completely — no PHX conversion, no Purchase event,
            // and a payment path the store is not set up for. PHX only hooks
            // the cart's checkout button, so we go to the cart and let it press
            // that real button (see assets/cart-boosters.js).
            window.location.href = '/cart?checkout=1';
          } else if (destination === 'cart') {
            window.location.href = '/cart';
          } else {
            self.resetButtons();
          }
        })
        .catch(function (err) {
          self.resetButtons();
          self.showError(err.message || 'Could not add to cart.');
        });
    }

    /**
     * Comma-joined ids of every section on the page that renders a cart, for
     * the `sections` parameter of /cart/add.js. The cart drawer lives inside
     * the header section, so on a product page this is normally the header.
     * Returns '' when there is nothing to refresh.
     */
    cartSectionIds() {
      var ids = [];
      var nodes = document.querySelectorAll('cart-items-component[data-section-id]');
      for (var i = 0; i < nodes.length; i++) {
        var id = nodes[i].dataset.sectionId;
        if (id && ids.indexOf(id) === -1) ids.push(id);
      }
      return ids.join(',');
    }

    /**
     * Tell the theme the cart changed, using the theme's own event.
     *
     * 'cart:update' is ThemeEvents.cartUpdate and also CartAddEvent.eventName.
     * Two things listen for it: <cart-drawer-component>, which opens itself
     * when it has the `auto-open` attribute, and <cart-items-component>, which
     * morphs its section from `detail.data.sections[sectionId]` — or re-fetches
     * the section itself if that key is absent, which is the fallback when the
     * add request came back without section HTML.
     *
     * This deliberately does NOT import CartAddEvent from '@theme/events'.
     * That class is a plain Event subclass that assigns `.detail` in its
     * constructor, so the shape below is identical, and keeping this file a
     * classic script (no module, no import map dependency) means the bundle
     * ladder still works if the theme's module graph ever changes.
     */
    announceCartUpdate(body) {
      try {
        var event = new Event('cart:update', { bubbles: true });
        event.detail = {
          resource: body || {},
          sourceId: 'bundle-tiers',
          data: {
            source: 'bundle-tiers',
            itemCount: body && typeof body.item_count === 'number' ? body.item_count : undefined,
            productId: this.dataset.productId,
            sections: (body && body.sections) || undefined
          }
        };
        document.dispatchEvent(event);
      } catch (e) {}
    }

    /**
     * Fires on `document` so a Shopify custom pixel, a GTM container or any
     * other listener can subscribe without knowing where this block sits.
     * Also mirrored onto window.dataLayer when one exists.
     */
    emit(name, detail) {
      detail.productId = this.dataset.productId;
      detail.productTitle = this.dataset.productTitle;
      try {
        document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push(Object.assign({ event: name }, detail));
        }
        // A Shopify custom pixel runs in a sandboxed iframe and CANNOT see
        // document events from this page. analytics.publish is the only
        // supported bridge into it, so the pixel subscribes to these names.
        // Colons are not allowed in published event names.
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name.replace(':', '_'), detail);
        }
      } catch (e) {}
    }

    resetButtons() {
      this.addButton.disabled = false;
      if (this.buyNowButton) this.buyNowButton.disabled = false;
      this.syncAddButton();
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }

    /* ---------- countdown ---------- */

    startTimer() {
      if (this.dataset.timerEnabled !== 'true') return;
      var el = this.querySelector('[data-bt-timer]');
      var clock = this.querySelector('[data-bt-clock]');
      if (!el || !clock) return;

      var minutes = Number(this.dataset.timerMinutes || 20);
      var deadline;
      try {
        var stored = Number(sessionStorage.getItem(TIMER_KEY));
        if (stored && stored > Date.now()) {
          deadline = stored;
        } else {
          deadline = Date.now() + minutes * 60000;
          sessionStorage.setItem(TIMER_KEY, String(deadline));
        }
      } catch (e) {
        deadline = Date.now() + minutes * 60000;
      }

      el.hidden = false;

      function tick() {
        var left = Math.max(0, deadline - Date.now());
        var mm = Math.floor(left / 60000);
        var ss = Math.floor((left % 60000) / 1000);
        clock.textContent = String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
        if (left <= 0) clearInterval(timer);
      }

      tick();
      var timer = setInterval(tick, 1000);
    }
  }

  customElements.define('bundle-tiers', BundleTiers);
})();
